import tokens from '@lacedltd/design-tokens/tokens'

// TODO window.innerWidth does not change on re-renders
export const isDesktop = () => window.innerWidth >= tokens.breakpoints.m

export const isSafari = () => window.safari !== undefined

export const isIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream

// Borrowed from https://stackoverflow.com/a/4819886
export const isTouchDevice = () => {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
  const mq = (query: string) => {
    return window.matchMedia(query).matches
  }

  if (
    'ontouchstart' in window ||
    (window.DocumentTouch && document instanceof window.DocumentTouch)
  ) {
    return true
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')

  return mq(query)
}

export const isProduction = () => {
  return process.env.RAILS_ENV === 'production'
}

export const isTestEnv = () => process.env.RAILS_ENV === 'test'
